// extracted by mini-css-extract-plugin
export default {"hairlineContainer":"hairline_hairlineContainer__yf1wO"};